export default {
  name: "Foreign Worker Information",
  prefix: "D",
  sections: [
    {
      fields: [
        {
          code: "D.1",
          machine_name: "fwInfoAppxA_attached",
          widget: "jump_to_step",
          label: `A completed Appendix A identifying the foreign workers being sponsored for permanent employment by the employer named in section A of this application is attached. *`,
          tooltip:
            "In order to request labor certification, the employer must <b>mark the “Yes” checkbox</b> to indicate that a completed <b>Appendix A</b> identifying the foreign worker being sponsored for permanent employment is attached to this application.  If the “No” checkbox is selected, the application will be denied.",
          jump_to_step: {
            buttonPrimary: "Go to Appendix A",
            step: 15,
          },
        },
        {
          isGroup: {
            code: "D.2",
            machine_name: "fwInfoAttyorAgent",
            required: true,
            label: `Has the employer contracted with an agent or attorney that also represents the foreign worker covered by this application?`,
            tooltip:
              "Identify whether the attorney/agent representing the foreign worker is also contracted with the employer by checking “Yes” or “No.”  Mark only one box.",
            coloring: "none",
            clearBtn: {
              clearSchema: ["fwInfoAttyorAgent"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
                setSchema: [{ set: "fwInfoAppxA_attached", to: 1 }],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                setSchema: [{ set: "fwInfoAppxA_attached", to: 1 }],
              },
            ],
          },
        },
      ],
    },
  ],
};
